import React from 'react'
import { CheckCircle } from "lucide-react";
interface Steps {
  currentStep: "discountInfo" | "eligibility";
  setCurrentStep: (step: "discountInfo" | "eligibility") => void;
}
    
const StepIndicator: React.FC<Steps> = ({
  currentStep,
  setCurrentStep,
}) => {

  const steps = [
    {id: "discountInfo", label: "Discount Information"},
    {id: "eligibility", label: "Eligibility & Conditions"}
  ]

  const isActive = (stepId: string) => currentStep === stepId;
  const isCompleted = (stepId: string) => {
    const stepOrder = steps.findIndex((step) => step.id === stepId);
    const currentStepOrder = steps.findIndex((step) => step.id === currentStep);
    return stepOrder < currentStepOrder;
  };
  return (
    <div className="mb-8">
      <div className="flex justify-between">
        {steps.map((step, index) => (
          <div
            key={step.id}
            className={`flex flex-col items-center relative ${
              index < steps.length - 1 ? "flex-1" : ""
            }`}
          >
            {/* Step connector line */}
            {index < steps.length - 1 && (
              <div
                className={`absolute w-full h-1 top-4 left-0 ${
                  isCompleted(step.id) || isCompleted(steps[index + 1].id)
                    ? "bg-green-500"
                    : "bg-gray-200"
                }`}
                style={{ width: "calc(100% - 1rem)", left: "1rem", zIndex: 0 }}
              ></div>
            )}

            {/* Step circle */}
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-white z-10
                ${isActive(step.id) ? "bg-[#047401]" : ""}
                ${isCompleted(step.id) ? "bg-[#047401]" : ""}
                ${!isActive(step.id) && !isCompleted(step.id) ? "bg-gray-200" : ""}
              `}
              onClick={() => isCompleted(step.id) && setCurrentStep(step.id as any)}
            >
              {isCompleted(step.id) ? (
                <CheckCircle size={20} />
              ) : (
                <span>{index + 1}</span>
              )}
            </div>

            {/* Step label */}
            <div
              className={`text-xs mt-2 font-medium
                ${isActive(step.id) ? "text-[#047401]" : ""}
                ${isCompleted(step.id) ? "text-[#047401]" : ""}
                ${!isActive(step.id) && !isCompleted(step.id) ? "text-gray-400" : ""}
              `}
            >
              {step.label}
            </div>
          </div>
        ))}
      </div>
    </div>
    );
  };

export default StepIndicator